// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoginToAccessAlert from "@steiner/App/Components/LoginToAccessAlert/LoginToAccessAlert";
import React from "react";
import { FC } from "react";
import { XNGAGE_ELEMENTS } from "@steiner/XDL/constants";

interface Props extends WidgetProps {}

const LoginToAccessAlertWidget: FC<Props> = props => {
    return <LoginToAccessAlert />;
};

const widgetModule: WidgetModule = {
    component: LoginToAccessAlertWidget,
    definition: {
        displayName: "Login To Access Alert",
        icon: "triangle-exclamation",
        group: XNGAGE_ELEMENTS,
    },
};

export default widgetModule;
